import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiMap, FiTruck, FiMapPin, FiFileText, FiPhone } = FiIcons;

const Sitemap = () => {
  const sections = [
    {
      title: "Main Pages",
      icon: FiFileText,
      links: [
        { label: "Home", path: "/" },
        { label: "Services", path: "/services" },
        { label: "Reminders", path: "/reminders" },
        { label: "About Us", path: "/about" },
        { label: "Blog & News", path: "/blog" },
        { label: "Questions & Answers (FAQ)", path: "/faq" },
        { label: "Contact", path: "/contact" }
      ]
    },
    {
      title: "Service Areas",
      icon: FiMapPin,
      links: [
        { label: "Ontario, CA", path: "/ontario-ca" },
        { label: "Rancho Cucamonga, CA", path: "/rancho-cucamonga-ca" },
        { label: "Upland, CA", path: "/upland-ca" },
        { label: "Fontana, CA", path: "/fontana-ca" },
        { label: "Chino, CA", path: "/chino-ca" },
        { label: "Pomona, CA", path: "/pomona-ca" },
        { label: "San Bernardino, CA", path: "/san-bernardino-ca" },
        { label: "Riverside, CA", path: "/riverside-ca" }
      ]
    },
    {
      title: "Our Services",
      icon: FiTruck,
      links: [
        { label: "CARB Compliance", path: "/services" },
        { label: "Clean Truck Check", path: "/services" },
        { label: "Diagnostics", path: "/services" },
        { label: "Force Regens", path: "/services" },
        { label: "Opacity Testing", path: "/services" },
        { label: "Fleet Maintenance", path: "/services" }
      ]
    }
  ];

  return (
    <div className="bg-gray-900 text-white min-h-screen">
      {/* Hero Section */}
      <section className="relative bg-gray-900 py-16 border-b border-gray-800">
        <div className="container mx-auto px-4 text-center">
          <motion.div 
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            className="inline-block p-4 rounded-full bg-blue-900/30 mb-6"
          >
            <SafeIcon icon={FiMap} className="text-4xl text-blue-500" />
          </motion.div>
          <motion.h1 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-4xl font-bold mb-4"
          >
            Sitemap
          </motion.h1>
          <p className="text-gray-400 max-w-2xl mx-auto">
            Overview of all pages and services available on Ramirez Mobile Clean Truck.
          </p>
        </div>
      </section>

      {/* Links Section */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {sections.map((section, index) => (
              <motion.div 
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
                className="bg-gray-800 p-8 rounded-xl border border-gray-700"
              >
                <div className="flex items-center space-x-3 mb-6 pb-4 border-b border-gray-700">
                  <SafeIcon icon={section.icon} className="text-2xl text-blue-500" />
                  <h2 className="text-xl font-bold text-white">{section.title}</h2>
                </div>
                <ul className="space-y-3">
                  {section.links.map((link, linkIndex) => (
                    <li key={linkIndex}>
                      <Link 
                        to={link.path} 
                        className="text-gray-400 hover:text-blue-400 transition-colors flex items-center space-x-2"
                      >
                        <span className="w-1.5 h-1.5 bg-blue-500 rounded-full"></span>
                        <span>{link.label}</span>
                      </Link>
                    </li>
                  ))}
                </ul>
              </motion.div>
            ))}
          </div>

          <div className="mt-12 text-center">
            <div className="bg-gray-800 inline-block p-8 rounded-xl border border-gray-700">
              <h3 className="text-xl font-bold text-white mb-2">Need Assistance?</h3>
              <p className="text-gray-400 mb-4">Can't find what you're looking for?</p>
              <a 
                href="tel:9092842738" 
                className="inline-flex items-center space-x-2 text-blue-400 font-bold hover:text-blue-300"
              >
                <SafeIcon icon={FiPhone} />
                <span>Call (909) 284-2738</span>
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Sitemap;